import React, { PureComponent } from 'react';
import cn from 'classnames';
import { string, func, object, oneOfType } from 'prop-types';

class CardHeader extends PureComponent {
  static propTypes = {
    tag: oneOfType([func, string]),
    className: string,
    innerRef: oneOfType([object, func, string]),
  };

  static defaultProps = {
    tag: 'div',
  };

  render() {
    const { className, tag: Tag, innerRef, titleLG, ...attributes } = this.props;
    return <Tag className={cn(className, 'card-header', { 'title-lg': titleLG })} ref={innerRef} {...attributes} />;
  }
}

export default CardHeader;
